<template>
  <vs-input
    class="inputx w-full"
    label="Guests"
    placeholder="Number of seats"
    type="number"
    v-model="selectedGuestCount"
    :disabled="disableComponent"
  />
</template>

<script>

export default {
  components: {},
  props: {
    guestCount: Number,
    disableComponent: Boolean,
  },
  data() {
    return {
      limitedGuestCount: 0,
    };
  },
  computed: {
    selectedGuestCount: {
      get() {
        return this.limitedGuestCount < 1 ? this.guestCount : this.limitedGuestCount;
      },
      set(newValue) {
        this.limitedGuestCount = Number.parseInt(newValue);
        if(this.limitedGuestCount < 1) this.limitedGuestCount = 1;

        this.$emit('guest-count-selected', this.limitedGuestCount);
      },
    },
  },
  watch: {
    guestCount(val, oldVal) {
      this.limitedGuestCount = val;
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
